import React,{Component} from 'react';
import {formatPrice} from '../helpers/helpers'

class Labor extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleDiscount =this.handleDiscount.bind(this)
        this.state = {
            product : {},
            total : 0,
            pretotal : 0,
            discount : 0
        }
        
    }
    handleChange(e){
        let product = this.state.product
        let update ={
                ...product,
                [e.target.name] : e.target.value
            }
            this.setState({
                product : update
            })
    }

    handleDiscount(e){
        
        let total = this.state.pretotal
        let discount = e.target.value/100
        let dis = total - (total * discount)
        
            this.setState({
                total : dis
            }) 
            this.setState({
                discount : e.target.value
            })
           
    }

    componentDidMount(){
        this.setState({
            product : this.props.product
        })
        
    }
    componentDidUpdate(prevProps,prevState){
        let quan = (this.state.product.number) ? this.state.product.number : 0;
        let laborPrice = (this.state.product.laborPrice) ? this.state.product.laborPrice : 0;

        if(prevState.product !== this.state.product){
            let data = parseInt(laborPrice,10) * parseInt(quan,10)
            this.setState({
                total : data,
                pretotal : data
            })
        }

        if(prevState.pretotal !== this.state.pretotal){
            if(this.state.discount > 0){

                let total = this.state.pretotal
                let discount = this.laborDiscount.value/100
                let dis = total - (total * discount)
            
                this.setState({
                    total : dis
                })               

            }
        }

        if(prevState.total !== this.state.total){
           this.props.setLaborTotal(this.props.index,this.state.total,this.state.discount,this.state.product.name,quan,laborPrice,this.state.product.unit) 
        }

        
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.product !== this.props.product){
            this.setState({
                product : nextProps.product
            })
        }
    }

    render() {     
                
        return (
            
                    <tr>
                        <td>
                            <p>{this.state.product.name}</p>
                            <input type="hidden" className="form-control" name="name"  value={this.state.product.name} ref={input => this.name = input}  />
                            
                        </td>
                        <td>                             
                            <input type="text" className="form-control" name="number" value={this.state.product.number} ref={input => this.number = input} onChange ={this.handleChange} />                                                       
                        </td>                       
                        <td>
                            <input type="text" className="form-control" value={this.state.product.laborPrice} name="laborPrice" ref={input => this.laborPrice = input} onChange ={this.handleChange} />                                                          
                        </td>
                        <td>
                           <input type="text" className="form-control"  name="laborDiscount" ref={input => this.laborDiscount = input} value={this.state.discount} onChange={this.handleDiscount} />
                        </td>                        
                        <td>
                            <p>{formatPrice(this.state.total)}</p>
                            <input type="hidden" className="form-control" value={this.state.total} name="total" ref={input => this.total = input} />
                        </td>
                    </tr>
                
 
        );
    }
}

export default  Labor;


// WEBPACK FOOTER //
// ./src/components/Labor.js